import { DtoExt } from '@/classes/scenario/DtoExt';

export class EcoCapexExt extends DtoExt {
  // PV
  public pvModule?: number | null = null;
  public pvRackSystem?: number | null = null;
  public pvInverter?: number | null = null;
  public pvInverterAcdcRatio?: number | null = null;
  public pvLogisticAndTransport?: number | null = null;

  // Others
  public otherAntiInjectionDevice?: number | null = null;
  public otherAcBillOfService?: number | null = null;
  public otherDcBillOfService?: number | null = null;
  public otherLogisticAndTransport?: number | null = null;

  // Structure
  public pvStructureCivilWorks?: number | null = null;
  public pvStructureShelter?: number | null = null;

  // Installation
  public projectInstallationPriceFixed?: number | null = null;
  public pvMechanicalInstallation?: number | null = null;
  public pvElectricalInstallation?: number | null = null;

  // Project
  public projectAffiliatesAndHq?: number | null = null;
  public projectEngineeringAndAdministrative?: number | null = null;
  public projectEpcMargin?: number | null = null;
  public projectSupervision?: number | null = null;

  // Generator
  public generatorBeforeDayCost?: number | null = null;
  public generatorBeforeNightCost?: number | null = null;
  public generatorBeforeLogisticAndTransport?: number | null = null;
  public generatorAfterDayCost?: number | null = null;
  public generatorAfterNightCost?: number | null = null;
  public generatorAfterLogisticAndTransport?: number | null = null;
  public generatorCostType1?: number | null = null;
  public generatorCostType2?: number | null = null;
  public generatorLogisticAndTransport?: number | null = null;

  // CHECKED ==========================================

  // Battery
  public batteryModule?: number | null = null;
  public batteryPriceReduction?: number | null = null;
  public batteryInverter?: number | null = null;
  public batteryLogisticAndTransport?: number | null = null;
  public batteryStructureCivilWorks?: number | null = null;
  public batteryStructureShelter?: number | null = null;
  public batteryMechanicalInstallation?: number | null = null;
  public batteryElectricalInstallation?: number | null = null;

  constructor(options?: EcoCapexExt | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }
}
